// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2yyjW","icon":"SortAdornment_icon__bOIzD","up":"SortAdornment_up__HVYYB","down":"SortAdornment_down__16DTu","active":"SortAdornment_active__3PEaO"};